import { OrderDetailsModal } from "@/features/orders/components/viewOrder/OrderDetailsModal";
import { type History, mapApiResponseToOrders, useDraftOrder } from "@repo/api";
import { Loading } from "@repo/skapa";
import { t } from "@repo/translation";
import { FlexDiv, ModalSheet } from "@repo/ui";

interface ViewDraftOrderModalProps {
  isOpen: boolean;
  closeModal: () => void;
  draftOrderId: string;
  historyEntries?: History[];
  activeTab?: string;
}

export const ViewDraftOrderModal = ({
  isOpen,
  closeModal,
  draftOrderId,
  historyEntries,
  activeTab,
}: ViewDraftOrderModalProps) => {
  const { data, isValidating } = useDraftOrder(draftOrderId);

  const draftOrderData = mapApiResponseToOrders(data, draftOrderId);

  const draftOrder = draftOrderData[0];

  return (
    <ModalSheet
      title={`${draftOrder?.orderAlias ?? t("label.draft_order")} - ${draftOrder?.orderNo}`}
      visible={isOpen}
      onClose={closeModal}
      onBack={closeModal}
    >
      {isValidating && (
        <FlexDiv justifyContent="center" alignItems="center">
          <Loading text={t("prompt.loading")} />
        </FlexDiv>
      )}
      {!isValidating && (
        <OrderDetailsModal
          order={draftOrder}
          historyEntries={historyEntries}
          activeTab={activeTab}
        />
      )}
    </ModalSheet>
  );
};
